module.exports = __webpack_public_path__ + "img/1273.9def3a17.jpg";